import React, {useState, useEffect, useMemo, useRef} from 'react';
import { useAuth } from '../contexts/authContext';
import Dashboard from './SideBar';
import { db } from '../firebase/firebase';
import {
    ClipboardDocumentListIcon, ComputerDesktopIcon, PencilIcon, UserGroupIcon, UsersIcon, XCircleIcon
} from "@heroicons/react/24/outline";
import {useDarkMode} from "../contexts/darkModeContext";
import {
    Button,
} from "@headlessui/react";

import {
    BookOpenIcon, BriefcaseIcon, CheckIcon, GlobeAltIcon,
    PlusIcon, ShieldCheckIcon, XMarkIcon,
} from "@heroicons/react/16/solid";
import {Link} from "react-router-dom";
import Task from "./JobBoard/Task";
import logo from "../GROLINKZ_ICON.png"
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";

const JobBoard = () => {
    const { currentUser } = useAuth();
    const { darkMode } = useDarkMode();


    const [employees, setEmployees] = useState([]);
    const [employeesUNCHANGED, setEmployeesUNCHANGED] = useState([]);
    const [tasks, setTasks] = useState([]);

    // const [tasks, setTasks] = useState(() => {
    //     // Check if there's saved state in localStorage
    //     const savedTasks = localStorage.getItem('tasks');
    //     return savedTasks ? JSON.parse(savedTasks) : []; // Parse or set empty array if not found
    // });
    //
    // const [employees, setEmployees] = useState(() => {
    //     // Check if there's saved state in localStorage
    //     const savedEmployees = localStorage.getItem('employees');
    //     return savedEmployees ? JSON.parse(savedEmployees) : []; // Parse or set empty array if not found
    // });
    //
    // // UseEffect to save tasks and employees to localStorage whenever they change
    // useEffect(() => {
    //     localStorage.setItem('tasks', JSON.stringify(tasks));
    //     localStorage.setItem('employees', JSON.stringify(employees));
    // }, [tasks, employees]);


    // Add Task
    const addTask = () => {
        const generateId = () => `task-${Date.now()}-${Math.floor(Math.random() * 1000)}`;

        setTasks((prevTasks) => [
            ...prevTasks,
            {
                id: generateId(),
                title: '',
                employees: [],
            },
        ]);
    };

    // Remove Task
    // const removeTask = (id) => {
    //     setTasks((prev) => prev.filter((task) => task.id !== id));
    // };

    const removeTask = (id) => {
        setTasks((prevTasks) => {
            // Find the task to be removed
            const taskToRemove = prevTasks.find((task) => task.id === id);

            // Get the employees assigned to this task
            const employeesToAddBack = taskToRemove ? taskToRemove.employees : [];

            // Remove the task from the tasks array
            const updatedTasks = prevTasks.filter((task) => task.id !== id);

            // Add the removed task's employees back to the employees list
            setEmployees((prevEmployees) => [
                ...prevEmployees,
                ...employeesToAddBack,
            ]);

            return updatedTasks;
        });
    };

    useEffect(() => {
        const fetchEmployees = async () => {
            if (currentUser) {
                try {
                    const storedTeamData = localStorage.getItem(`teamData_${currentUser.uid}`);
                    if (storedTeamData) {
                        const teamData = JSON.parse(storedTeamData);
                        setEmployees(teamData);
                        setEmployeesUNCHANGED(teamData);
                    } else {
                        const teamCollectionRef = db.collection('Users').doc(currentUser.uid).collection('team');
                        const snapshot = await teamCollectionRef.get();
                        if (!snapshot.empty) {
                            const teamData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                            setEmployees(teamData);
                            setEmployeesUNCHANGED(teamData);
                            localStorage.setItem(`teamData_${currentUser.uid}`, JSON.stringify(teamData));
                        } else {
                            console.log('No employees found');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching employees:', error);
                }
            }
        };
        fetchEmployees();
    }, [currentUser]);

    const onDragEnd = (result) => {
        const { destination, source, draggableId } = result;

        if (!destination) return; // If dropped outside any valid drop area

        // Example: if dragged to a new task
        if (source.droppableId !== destination.droppableId) {
            // Find the employee based on draggableId
            const employee = employees.find((e) => e.id === draggableId);

            // Remove the employee from the employees pool
            const updatedEmployees = employees.filter((e) => e.id !== draggableId);

            // Find the task where the employee is being assigned
            const updatedTasks = tasks.map((task) => {
                if (`task-${task.id}` === destination.droppableId) {
                    return {
                        ...task,
                        employees: [...task.employees, employee],
                    };
                }
                return task;
            });

            // Update the state with the modified tasks and employees
            setTasks(updatedTasks);
            setEmployees(updatedEmployees);
        }
    };


    return (
        <div className={`${darkMode ? "text-white" : ""} flex h-full w-full p-3`}>


            {/*Body*/}
            <DragDropContext onDragEnd={onDragEnd}>
                <div className="w-full z-20 max-h-[calc(100vh-5.5rem)] animate-fadeIn grid grid-cols-5 gap-x-3">

                    {/*Employee List*/}
                    <div className={`col-span-1 rounded-lg border ${darkMode ? "bg-bgDark border-neutral-700" : "bg-white"}`}>

                        {/*Header*/}
                        <div className={`relative text-center h-14 flex flex-col p-1.5 border-b-2 ${darkMode ? 'border-neutral-700' : ''}`}>

                            <div className={`absolute top-1 left-1 gap-x-1 flex items-center border rounded-md px-0.5 border-red-600 bg-red-500/20`}>
                                <XMarkIcon className={`text-red-500 size-4`}/>
                                <div className={`text-xs`}>{employees.length}</div>
                            </div>

                            <div className={`absolute top-1 right-1 gap-x-1 flex items-center border rounded-md px-0.5 border-green-600 bg-green-500/20`}>
                                <CheckIcon className={`text-green-500 size-4`}/>
                                <div className={`text-xs`}>{employeesUNCHANGED.length - employees.length}</div>
                            </div>

                            <div className={`tracking-widest mt-auto font-semibold`}>Team Members</div>
                        </div>

                        {/*Array*/}
                        <div className={`h-[calc(100dvh-9.5rem)] rounded-lg scrollbar-none`}>
                            {/*h-[calc(100dvh-9.5rem)] rounded-lg overflow-y-auto scrollbar-none*/}
                            {employees.length === 0 ? (
                                // Display custom dialog if sprays array is empty
                                <div className="flex items-center justify-center h-full">
                                    <div className="text-center">
                                        <UserGroupIcon className={`mx-auto size-12 text-gray-400`}/>
                                        <h3 className="mt-2 text-lg tracking-widest font-semibold">No Employees</h3>
                                        <p className="mt-1 text-sm tracking-tighter text-gray-500">Add employees in your management page.</p>
                                        <div className="mt-6">
                                            <Button
                                                type="button"
                                                // onClick={addTask}
                                                className="inline-flex items-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                            >
                                                <PlusIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5"/>
                                                Add Employee
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                // Display SprayCard components if sprays array is not empty
                                <div className="grid grid-cols-1 p-3 gap-3 auto-rows-auto">

                                    <Droppable droppableId="employees">
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                className={`space-y-3`}
                                            >
                                                {employees.map((employee, index) => (
                                                    <Draggable draggableId={employee.id} index={index}
                                                               key={employee.id}>
                                                        {(provided) => (
                                                            <div
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                className={`flex items-center border-2 ${darkMode ? 'bg-bgcard/20 border-neutral-700 text-white shadow-xl' : 'bg-white text-black shadow-md'} p-1 rounded-lg cursor-pointer`}
                                                            >
                                                                <div className={`rounded-full w-12 h-12 flex items-center border ${darkMode ? 'border-neutral-700' : ''}`}>
                                                                    <img
                                                                        alt={''}
                                                                        src={logo}
                                                                        className={`w-12 object-cover`}
                                                                    />
                                                                </div>

                                                                <div className={`flex flex-col`}>
                                                                    <div className={`ml-2 text-sm line-clamp-1 tracking-widest`}>{employee.name}</div>
                                                                    <div className={`ml-2 text-xs line-clamp-1 text-gray-500 tracking-tighter`}>{employee.position}</div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </div>
                                        )}
                                    </Droppable>

                                </div>

                            )}

                        </div>

                    </div>

                    {/*Job Board*/}
                    <div className={`col-span-4 rounded-lg border ${darkMode ? "bg-bgDark border-neutral-700" : "bg-white"}`}>

                        {/*Header*/}
                        <div className={`grid grid-cols-2 p-1.5 border-b-2 ${darkMode ? 'border-neutral-700' : ''}`}>

                            <div className={`flex col-span-1 flex-col`}>
                                <div className={`indent-2 flex items-center tracking-widest text-lg`}>
                                    Job Board
                                    <Button className={`flex ml-6 text-white hover:bg-opacity-50 items-center bg-green-600 rounded-md px-2 text-xs h-fit py-0.5`}>
                                        <PencilIcon className={`w-3 mr-2`}/>Edit
                                    </Button>
                                </div>
                                <div className={`indent-8 text-gray-500 text-xs`}>Select and Assign tasks to you entire team</div>
                            </div>

                            <div className={`flex items-center col-span-1 flex-row`}>
                                <Button onClick={addTask} className={`ml-auto flex hover:bg-opacity-50 text-white items-center bg-blue-600 text-sm px-2 py-1 rounded-md h-fit`}>
                                    <PlusIcon className={`w-3 mr-2`}/> Add a New Task
                                </Button>

                                <Button className={`ml-4 mr-3 flex hover:bg-opacity-50 text-white items-center bg-green-600 text-sm px-2 py-1 rounded-md h-fit`}>
                                    <CheckIcon className={`w-3 mr-2`}/> Save
                                </Button>
                            </div>

                        </div>

                        {/*Tasks List*/}
                        <div className={`w-full h-[calc(100dvh-9.5rem)] rounded-lg overflow-y-auto scrollbar-none`}>

                            {tasks.length === 0 ? (
                                // Display custom dialog if sprays array is empty
                                <div className="flex items-center justify-center h-full">
                                    <div className="text-center">
                                        <ComputerDesktopIcon className={`mx-auto size-12 text-gray-400`}/>
                                        <h3 className="mt-2 text-lg tracking-widest font-semibold">No Tasks or Jobs</h3>
                                        <p className="mt-1 text-sm tracking-tighter text-gray-500">Get started by creating a new task/Job.</p>
                                        <div className="mt-6">
                                            <Button
                                                type="button"
                                                onClick={addTask}
                                                className="inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                                            >
                                                <PlusIcon aria-hidden="true" className="-ml-0.5 mr-1.5 size-5"/>
                                                New Task
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className={`grid grid-cols-3 gap-3 p-3`}>
                                    {tasks.map((task, index) => (
                                        <Task
                                            key={task.id}
                                            index={task.id}
                                            task={task}
                                            employees={employees}
                                            setEmployees={setEmployees}
                                            setTasks={setTasks}
                                            onRemove={() => removeTask(task.id)}
                                        />
                                    ))}
                                </div>
                            )}


                        </div>
                    </div>

                </div>
            </DragDropContext>

        </div>
    );
};

export default JobBoard;
